export default __webpack_public_path__ + "static/media/Plotka.69f62fd3.png";